import { HubConnectionBuilder, LogLevel } from '@aspnet/signalr';

const signalHubList = {};
export default {
  init: async function(hubName, host) {
    let url = `${window.location.origin}/${hubName}`;
    if (host) {
      url = `${host}/${hubName}`;
    }

    const hub = new HubConnectionBuilder()
      .withUrl(url)
      .configureLogging(LogLevel.Information)
      .build();
    signalHubList[hubName] = hub;

    hub.onclose(async () => {
      await this.reconnect(hubName);
    });

    await hub.start();
    return hub;
  },

  get: function (hubName) {
    return signalHubList[hubName];
  },

  stop: async function(hubName) {
    if (Object.hasOwn(signalHubList, hubName)) {
      await signalHubList[hubName].stop();
      delete signalHubList[hubName];
    }
  },

  reconnect: async function (hubName) {
    const hub = signalHubList[hubName];

    if (!hub) {
      return;
    }

    try {
      // eslint-disable-next-line no-console
      console.log(`Reconnecting hub ${hubName}...`);
      await hub.start();
    }
    catch (e) {
      // eslint-disable-next-line no-console
      console.log(`Reconnect failed: ${e}`);
    }
  },
};